import { render, staticRenderFns } from "./PDFFile.vue?vue&type=template&id=486bfe5a&lang=pug&"
import script from "./PDFFile.vue?vue&type=script&lang=ts&"
export * from "./PDFFile.vue?vue&type=script&lang=ts&"
import style0 from "./PDFFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486bfe5a')) {
      api.createRecord('486bfe5a', component.options)
    } else {
      api.reload('486bfe5a', component.options)
    }
    module.hot.accept("./PDFFile.vue?vue&type=template&id=486bfe5a&lang=pug&", function () {
      api.rerender('486bfe5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/icons/PDFFile.vue"
export default component.exports